// Mock data for EPG España Landing Page

export const mockDataEspanol = {
  header: {
    logoText: "EPG España",
    buttons: [
      { text: "Reserva una llamada", type: "outline" },
      { text: "Confidencialidad", type: "outline" }
    ]
  },
  hero: {
    badge: "Invertimos en metales preciosos desde 2015",
    headline: "¡Invierte en oro y plata estableciendo tus propios criterios!",
    subheading: "¡Bienvenido a Electrum Prosperity Group España!",
    benefits: [
      "Distribuidor autorizado de metales preciosos, conforme a las regulaciones",
      "Almacenamiento seguro y servicios logísticos dedicados",
      "Bonificaciones en oro por referencias confirmadas",
      "Plataforma simple de administrar, directamente desde el teléfono"
    ],
    stats: [
      { value: "+$80", label: "En oro por", sublabel: "cada recomendación" },
      { value: "$500", label: "Recompensas", sublabel: "EFECTIVO" },
      { value: "$820", label: "Potencial", sublabel: "TOTAL" },
      { value: "Pagos", label: "semanales", sublabel: "" }
    ],
    ctas: [
      { text: "Reserva una llamada", type: "primary" },
      { text: "¡Únete ahora!", type: "secondary" }
    ],
    email: "electrumpg@gmail.com",
    videoUrl: process.env.REACT_APP_VIDEO_URL || "https://www.7kmetals.com/stusimonsen/share/xyt25"
  },
  features: [
    {
      title: "4 AMIGOS REFERIDOS = 820 USD",
      description: "Gana $320 USD en oro puro (4 x $80) + $500 en recompensas en efectivo. Más que el costo de la membresía Legacy."
    },
    {
      title: "¿ESTÁS LISTO PARA COMENZAR?",
      description: "Si estás preparado para empezar, te proporcionamos la capacitación completa. No se requiere experiencia previa."
    },
    {
      title: "¡DESCUBRE MÁS!",
      description: ""
    }
  ],
  contactForm: {
    title: "Contacto",
    fields: [
      { name: "name", type: "text", placeholder: "Nombre completo", required: true },
      { name: "email", type: "email", placeholder: "Correo electrónico", required: true },
      { name: "phone", type: "tel", placeholder: "Teléfono", required: true }
    ],
    privacyText: "Acepto la política de privacidad",
    submitText: "Enviar",
    successMessage: "¡Gracias! El formulario se envió correctamente. Nos pondremos en contacto contigo pronto.",
    errorMessage: "Ocurrió un error. Por favor, inténtalo de nuevo.",
    privacyError: "Debes aceptar la política de privacidad."
  },
  testimonials: [
    {
      name: "María González",
      role: "Inversora",
      text: "EPG me ha ayudado a proteger mi patrimonio y generar ingresos adicionales. ¡Una oportunidad increíble!"
    },
    {
      name: "Carlos Rodríguez",
      role: "Emprendedor",
      text: "La plataforma es fácil de usar y el soporte es excelente. Recomiendo EPG a todos."
    },
    {
      name: "Ana Martínez",
      role: "Profesional",
      text: "Finalmente encontré una forma segura de invertir en metales preciosos. ¡Gracias EPG!"
    }
  ]
};
